// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__k-gYv","image":"styles_image__V1zHv"};